import { PayloadAction } from '@reduxjs/toolkit'
import { call, put, takeLatest } from 'redux-saga/effects'

import establishmentModel, { Establishment } from '@/core/models/establishment.model'

import {
  getEstablishment as getEstablishmentAction,
  getEstablishmentSuccess as getEstablishmentSuccessAction,
  getEstablishmentFailure as getEstablishmentFailureAction,
} from '@/redux/reducers/establishment.reducer'

import { handleError } from '@/utils/errors'

function* getEstablishment(action: PayloadAction<string>) {
  try {
    const establishmentId = action.payload
    const establishment: Establishment = yield call(establishmentModel.getEstablishment, establishmentId)
    yield put(getEstablishmentSuccessAction(establishment))
  } catch (exception) {
    yield put(getEstablishmentFailureAction(handleError(exception)))
  }
}

const sagas = [takeLatest(getEstablishmentAction.type, getEstablishment)]

export default sagas
